(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-update"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accessibilityTriggerButtons = document.querySelectorAll('[data-open-accessibility]');
    const accessibilityMenuButton = document.querySelector('.asw-menu-btn');

    if (!accessibilityMenuButton) {
      return;
    }

    accessibilityTriggerButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        accessibilityMenuButton.click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  const filters = document.querySelectorAll('.product-reviews__filters-item');
  const items = document.querySelectorAll('.product-reviews-item');

  if (!filters || !items) return;

  const toggleVisibilityReviews = () => {
    const activeType = document.querySelector('.product-reviews__filters-item--active').dataset.type.trim();

    items.forEach((item) => {
      item.parentNode.classList.toggle('product-reviews-item__wrapper--active', item.dataset.type === activeType);
    });
  };

  filters.forEach((filter) => {
    filter.addEventListener('click', (e) => {
      filters.forEach((filter) => {
        filter.classList.toggle('product-reviews__filters-item--active', e.target === filter);
      });
      toggleVisibilityReviews();
    });
  });

  toggleVisibilityReviews();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function readStored(key) {
      try {
        return parseInt(localStorage.getItem(key), 10);
      } catch (e) {
        return NaN;
      }
    }

    function writeStored(key, value) {
      try {
        localStorage.setItem(key, String(value));
      } catch (e) {
        /* private mode / storage disabled — fallback lives on the element */
      }
    }

    function getDeadline(el) {
      var durationMs = (parseInt(el.dataset.durationMinutes, 10) || 120) * 60 * 1000;
      var key = el.dataset.storageKey;
      var now = Date.now();
      var deadline = key ? readStored(key) : NaN;

      if (isNaN(deadline)) deadline = el.promoDeadline;

      if (isNaN(deadline) || typeof deadline !== 'number' || deadline <= now) {
        deadline = now + durationMs;
        if (key) writeStored(key, deadline);
      }

      el.promoDeadline = deadline;
      return deadline;
    }

    function tick() {
      var timers = document.querySelectorAll('[data-promo-countdown]');
      if (!timers.length) return;
      timers.forEach(function (t) {
        var diff = Math.max(0, Math.floor((getDeadline(t) - Date.now()) / 1000));
        var dEl = t.querySelector('[data-days]');
        var hEl = t.querySelector('[data-hours]');
        var mEl = t.querySelector('[data-minutes]');
        var sEl = t.querySelector('[data-seconds]');
        // With the days unit shown, hours wrap at 24; otherwise they hold the full remainder.
        var hours = dEl ? Math.floor((diff % 86400) / 3600) : Math.floor(diff / 3600);
        if (dEl) {
          var days = String(Math.floor(diff / 86400));
          dEl.textContent = dEl.dataset.pad === 'false' ? days : days.padStart(2, '0');
        }
        if (hEl) hEl.textContent = String(hours).padStart(2, '0');
        if (mEl) mEl.textContent = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
        if (sEl) sEl.textContent = String(diff % 60).padStart(2, '0');
      });
    }

    tick();
    setInterval(tick, 1000);
    document.addEventListener('shopify:section:load', tick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sticky-cta-bar')) return;

    class StickyCtaBar extends HTMLElement {
      connectedCallback() {
        this.visible = new Set();
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0 });
        this.getHideTargets().forEach((el) => this.observer.observe(el));

        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.handleClick);
      }

      getHideTargets() {
        const selectors = (this.dataset.hideSelectors || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
        const targets = new Set();

        selectors.forEach((selector) => {
          try {
            document.querySelectorAll(selector).forEach((el) => {
              // Never observe the bar itself or anything that contains it.
              if (!el.contains(this) && !this.contains(el)) targets.add(el);
            });
          } catch (e) {
            // Invalid selector entered in the editor; skip it without breaking the rest.
          }
        });

        return targets;
      }

      handleIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.visible.add(entry.target);
          } else {
            this.visible.delete(entry.target);
          }
        });

        this.toggleAttribute('data-hidden', this.visible.size > 0);
      }

      handleClick(event) {
        const link = event.target.closest('.sticky-cta-bar__button');
        const href = link?.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        event.preventDefault();
        if (href === '#') return;

        let target = null;
        try {
          target = document.querySelector(href);
        } catch (e) {
          target = document.getElementById(href.slice(1));
        }
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    customElements.define('sticky-cta-bar', StickyCtaBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const subscribeBar = document.getElementById('subscribe-bar');
    const footer = document.getElementById('footer');

    if (!subscribeBar) {
      return;
    }

    if (footer) {
      footer.style.paddingBottom = subscribeBar.offsetHeight + 10 + 'px';
    }

    const hideTriggers = document.querySelectorAll('[data-hide-subscribe]');

    // A set, not a counter: the first callback reports hidden triggers too, which pushed the counter below zero
    const visibleTriggers = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleTriggers.add(entry.target);
          } else {
            visibleTriggers.delete(entry.target);
          }
        });

        if (visibleTriggers.size > 0) {
          subscribeBar.classList.add('subscribe-bar--hidden');
        } else {
          subscribeBar.classList.remove('subscribe-bar--hidden');
        }
      },
      {
        threshold: 0.1,
      }
    );

    hideTriggers.forEach((el) => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();
})();
